<!--<header class="header-panel" *ngIf="currentUrl" [ngClass]="isPatentPlusUser ? 'patent-plus-design' : ''">-->
<header class="header-panel" *ngIf="currentUrl">
    <!--<nav class="navbar navbar-expand-lg fixed-top shadow-sm bg-white patent-plus-logo" *ngIf="currentUrl" [ngClass]="isPatentPlusUser ? 'patent-plus-design' : currentUrl[1].includes('contract-remote') ? 'contract-remote-header' : ''">-->
    <nav class="navbar navbar-expand-lg fixed-top shadow-sm bg-white patent-plus-logo" *ngIf="currentUrl" [ngClass]="currentUrl[1].includes('contract-remote') ? 'contract-remote-header' : ''">
        <div class="header-main-panel" id="navbarToggle">
            <div class="left-panel">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <button class="btn btn-success" id="backButton" (click)="clickOnBack()" [hidden]="contactId == 0 || _transferDataService.showHideBtn == 'Hide'">
                            <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
                            <span>{{backToContact}}</span>
                        </button>
                    </li>
                    <!--<li *ngIf="message">
                        <span class="font-ipad text-left" *ngIf="currentUrl && currentUrl.length > 4 && (connectionStatus == 1 || connectionStatus == 2 || connectionStatus == 3) && currentUrl[1] == 'contract-remote'" style=" color: green; font-weight: bold; font-size: 14px;">
                            {{clientConnected}}
                            <img id="imgConnected" src="assets/images/ccImages/connected.gif" />
                            <i id="pauseConnection" class="fa fa-pause-circle" (click)="pauseConnection()" [hidden]="connectionStatus == 2"></i>
                            <i id="resumeConnection" class="fa fa-play-circle" (click)="resumeConnection()" [hidden]="connectionStatus == 1 || connectionStatus == 3"></i>
                        </span>
                        <div class="font-ipad text-left" *ngIf="currentUrl && currentUrl.length > 4 && (connectionStatus == 0 || connectionStatus == -1)  && currentUrl[1] == 'contract-remote'">
                            <span>{{clientConnected}}</span>
                            <img id="imgnotConnected" src="assets/images/ccImages/notConnected.gif" />
                        </div>
                    </li>-->
                    <li class="gif-loader-center">
                        <div class="loader-middle" *ngIf="currentUrl && (connectionStatus == 0 || connectionStatus == -1)  && (currentUrl[1].includes('contract-remote'))">
                            <img id="hourGlass" src="assets/images/ccImages/SignalRLoader1.gif" />
                            <span class="text-centered">Connecting...</span>
                        </div>
                    </li>
                </ul>
            </div>

            <!--   Show this only lg screens and up   -->
            <div class="center-panel" *ngIf="logoPath != undefined">
                <a class="navbar-brand">
                    <img id="imgLogo" src={{logoPath}} />
                    <span class="version-text">{{this.appVersion}}</span>
                </a>
            </div>

            <div class="right-panel">
                <ul class="navbar-nav">
                    <li *ngIf="currentUrl && currentUrl.length > 4 && (currentUrl[1] == 'contract' || currentUrl[1] == 'patent-plus-contract' || currentUrl[1].includes('contract-remote'))">
                        <span><b>File#</b> </span>
                        <input style="width:50px; text-align:center; border:solid 1px #ccc; border-radius:3px; margin-left:5px;" type="text" id="fileNumber" [(ngModel)]="fileNo" maxlength="4" (keypress)="allowNumeric($event)" />
                        <button type="button" id="floppy" class="btn-save-active" title="Update File Number" (click)="updateFileNumber()">
                            <i class="fa fa-save"></i>
                        </button>
                    </li>
                    <li class="contract-list-btn">
                        <span style="margin-right:5px;" class="font-ipad" *ngIf="currentUrl && currentUrl.length > 4 && (currentUrl[1] == 'contract' || currentUrl[1] == 'patent-plus-contract' || currentUrl[1].includes('contract-remote')) && clientCountry != 399">
                            {{ clientCountry == 4 ? 'United Kingdom' :clientCountry == 6 ? 'Ireland' : clientCountry == 3 ? 'Australia' : clientCountry == 2 ? 'Canada': 'USA,' }}&nbsp;{{clientState}}
                        </span>
                        <span style="margin-right:5px;" class="font-ipad" *ngIf="currentUrl && currentUrl.length > 4 && (currentUrl[1] == 'contract' || currentUrl[1] == 'patent-plus-contract' || currentUrl[1].includes('contract-remote')) && clientCountry == 399 ">
                            {{otherCountry}},&nbsp;{{clientState}}
                        </span>
                        <button class="btn btn-success contact-btn" id="backContractList" (click)="clickBackContractList()" [hidden]="contactId == 0 || _transferDataService.showHideBtn == 'Hide'">
                            <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
                            <span>Contract List</span>
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</header>

<div class="modal fade contract-modalV1" id="modalUpdateFileNumber" tabindex="-1" role="dialog" aria-labelledby="modalUpdateFileNumber" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered model-sm" role="Document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title text-left" id="modalUpdateFileNumberTitle">Alert!</h4>
            </div>
            <div class="modal-body">
                <div class="">
                    <div class="row">
                        <div class="col-sm-12" style="margin-top:20px">
                            <div *ngIf="!isSecondContract; else secondFileNumberMessage">
                                <h5>{{fileNo}} is already reserved. Please provide a different file number.</h5>
                            </div>
                            <ng-template #secondFileNumberMessage>
                                <h5>{{contractNumber}} corresponds with the contact’s BIP contract, Are you sure you want to change it?</h5>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" *ngIf="!isSecondContract; else secondFileNumberButton" id="closeFileButton" class="mat-raised-button mat-warn pull-right" data-dismiss="modal" title="Close">Close</button>
                <ng-template #secondFileNumberButton>
                    <button class="btn btn-success" (click)="assignedDuplicateFileNo('Yes')" title="Yes">Yes</button>
                    <button class="btn btn-danger" (click)="assignedDuplicateFileNo('No')" title="No">No</button>
                </ng-template>
            </div>
        </div>
    </div>
</div>
